/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  GetPresentationListsService,
  IGetPresentationListsMethods,
  IGetLabelPDFMethods,
  GetLabelPDFService,
  IAddSerialNoMethods,
  AddSerialNoService,
} from "./components";

export type PrintLabelPageAgent = IStaticPageContentMethods &
  IGetPresentationListsMethods &
  IGetLabelPDFMethods &
  IAddSerialNoMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new GetPresentationListsService(),
    new GetLabelPDFService(),
    new AddSerialNoService(),
  ];
};

export const getAgent = () => {
  return createAgent<PrintLabelPageAgent>({
    plugins: getPlugins(),
  });
};
